import React, { useContext } from 'react';
import { TableCell, TableHead, TableRow, TableSortLabel, Button, } from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { DatasetSelectionCtx, FileSelectionCtx, emptyFileSelection, emptyDatasetSelection, } from '../../App/ApplicationContext';
import { CustomizedTooltip } from '../../GenericUI/CustomizedTooltip';
import { PROJECTNAME } from '../../../types/searchTypes';
const classes = {
    visuallyHidden: {
        border: '0px',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0px',
        position: 'absolute',
        top: '20px',
        width: 1,
    },
};
export const DatasetTableHead = ({ orderBy, order, onRequestSort, rows, }) => {
    var _a;
    const { selectDatasets } = useContext(DatasetSelectionCtx);
    const { selectFiles } = useContext(FileSelectionCtx);
    const headCells = [
        {
            id: 'id',
            label: 'Dataset',
            numeric: false,
            disablePadding: false,
            badge: false,
            description: '',
        },
        {
            id: 'dataNode',
            label: 'Mirror (Node)',
            numeric: false,
            disablePadding: false,
            badge: false,
            description: '',
        },
        {
            id: 'version',
            label: 'Version',
            numeric: false,
            disablePadding: false,
            badge: false,
            description: 'Latest update',
        },
        {
            id: 'fileNumber',
            label: 'Files',
            numeric: false,
            disablePadding: false,
            badge: false,
            description: 'Number of links',
        },
        {
            id: 'size',
            label: 'Size',
            numeric: false,
            disablePadding: false,
            badge: false,
            description: 'Total size of dataset',
        },
        {
            id: 'citationUrl',
            label: 'Doc',
            numeric: false,
            disablePadding: false,
            badge: false,
            description: 'Dataset Documentation',
        },
    ];
    if (((_a = rows[0]) === null || _a === void 0 ? void 0 : _a.projectName) === PROJECTNAME.CMIP5) {
        headCells.splice(3, 1);
    }
    const createSortHandler = (property) => {
        onRequestSort(property);
    };
    return (React.createElement(TableHead, null,
        React.createElement(TableRow, null,
            React.createElement(TableCell, null,
                React.createElement(CustomizedTooltip, { title: 'Select all datasets', placement: 'top' },
                    React.createElement(Button, { variant: 'text', startIcon: React.createElement(ListIcon, null), style: { backgroundColor: '#f5f5f5', paddingRight: 8 }, size: 'small', color: 'primary', onClick: () => {
                            selectDatasets(rows);
                            selectFiles(emptyFileSelection);
                        } }, "All"))),
            React.createElement(TableCell, null,
                React.createElement(CustomizedTooltip, { title: 'Clear selected data', placement: 'top' },
                    React.createElement(Button, { variant: 'text', style: { backgroundColor: '#f5f5f5', paddingRight: 8 }, color: 'primary', startIcon: React.createElement(CheckCircleOutlineIcon, null), size: 'small', onClick: () => {
                            selectDatasets(emptyDatasetSelection);
                            selectFiles(emptyFileSelection);
                        } }, "None"))),
            headCells.map((headCell) => (React.createElement(TableCell, { key: headCell.id, align: 'center', padding: headCell.disablePadding ? 'none' : 'normal', sortDirection: orderBy === headCell.id ? order : false },
                React.createElement(CustomizedTooltip, { title: headCell.description, placement: 'top' },
                    React.createElement(TableSortLabel, { active: orderBy === headCell.id, direction: 
                        // eslint-disable-next-line no-nested-ternary
                        orderBy === headCell.id
                            ? order === 'asc'
                                ? 'asc'
                                : 'desc'
                            : 'asc', onClick: () => {
                            createSortHandler(headCell.id);
                        } },
                        headCell.label,
                        orderBy === headCell.id ? (React.createElement("span", { style: classes.visuallyHidden }, order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending')) : null))))))));
};
